import { api } from "./index";
import { PageRequest, PageResponse } from "../../shared/types/page";
import { ConfigurationUpdateRequest, ConfigurationView } from "../../shared/types/configuration";

export const getAllConfigurationsFetch = async (
    pageRequest: PageRequest
): Promise<PageResponse<ConfigurationView>> => {
    const response = await api.post<PageResponse<ConfigurationView>>(
        `/views/configurations/paginate`,
        pageRequest
    );
    return response.data;
};

export const updateConfigurationFetch = async (
    id: number,
    request: ConfigurationUpdateRequest
): Promise<ConfigurationView> => {
    const response = await api.patch<ConfigurationView>(
        `/configurations/${id}`,
        request
    );
    return response.data;
};
